module.exports = __webpack_public_path__ + "static/media/Autonation.723df542.svg";